<template>
  <div class="vue-wrapper">
    <div v-for="modal in modalStack" v-bind:key="modal.modalName" class="modal-container" :class="{active: isContainerActive}">
      <div v-if="!modal.modalProps.internalWindow" class="modal-window" :class="getWindowClass(modal)">
        <v-component v-bind:is="modal.modalName" v-bind="modal.modalProps" v-on:close="onClose(modal)"></v-component>
      </div>
      <v-component v-else v-bind:is="modal.modalName" v-bind="modal.modalProps" v-on:close="onClose(modal)"></v-component>

      <div class="modal-overlay" @click="onClose(modal)"></div>
    </div>
  </div>
</template>

<script>
import KundeCardCreateModal from './Admin/KundeCardCreateModal'
import KundeKontraktCreateModal from './Admin/KundeKontraktCreateModal'
import KundeKontraktObjektCreateModal from './Admin/KundeKontraktObjektCreateModal'
import KundeKontraktObjekt from './Admin/KundeKontraktObjekt'

// NEW FOR TESTING
import KundeKontraktObjektModal from './Admin/KundeKontraktObjektModal'

import KundeKontraktSidebarNotater from './Admin/KundeKontraktSidebarNotater'
import KundeKontraktSidebarHistorikk from './Admin/KundeKontraktSidebarHistorikk'
import KundeFullmaktFormModal from './Admin/KundeFullmaktFormModal'
import KunstnerFormModal from './Admin/KunstnerFormModal'
import AuksjonFormModal from './Admin/AuksjonFormModal'
import KundeKontraktObjektSidebarNotater from './Admin/KundeKontraktObjektSidebarNotater'
import KundeKontraktTransferModal from './Admin/KundeKontraktTransferModal'
import UserProfileModal from './Admin/UserProfileModal'
import HistoryItemModal from './Admin/HistoryItemModal'
import KundeKontraktPrintModal from './Admin/KundeKontraktPrintModal'
import PrintLabelsModal from './Admin/PrintLabelsModal'
import KunstnerObjektListModal from './Admin/KunstnerObjektListModal'
import KundeKontraktObjektTabKjoperBilagModal from './Admin/KundeKontraktObjektTabKjoperBilagModal'
import KundeKontraktObjektTabSelgerBilagModal from './Admin/KundeKontraktObjektTabSelgerBilagModal'
import KundeKontraktObjektTabSelgerBilagDraftModal from './Admin/KundeKontraktObjektTabSelgerBilagDraftModal'
import KundeKontraktInvoiceArModal from './Admin/KundeKontraktInvoiceArModal'
import MultiInvoiceModal from './Admin/MultiInvoiceModal'
import KundeAdresseModal from './Admin/KundeAdresseModal'
import KundeKycModal from './Admin/KundeKycModal'
import BilagPdfModal from './Admin/BilagPdfModal'
import KrediteringBilagModal from './Admin/KrediteringsBilagModal'
import KrediteringsBilagFakturaModal from './Admin/KrediteringsBilagFakturaModal'
import TheConfirm from './TheConfirm'
import EoFakturaModal from './Admin/EoFakturaModal'
import HistoryItemKontraktPdfModal from './Admin/HistoryItemKontraktPdfModal'
import HistoryItemBesiktPdfModal from './Admin/HistoryItemBesiktPdfModal'
import ResultatbrevPrintModal from './Admin/Reports/ResultatbrevPrintModal'
import BekreftelsebrevPrintModal from './Admin/Reports/BekreftelsebrevPrintModal'
import KundeKontraktObjektBesiktelseModal from './Admin/KundeKontraktObjektBesiktelseModal'
import DashboardOppgaveModal from './Admin/Dashboard/ModalOppgave'
import LoginModal from './Guest/LoginModal'
import BilagEmailPdfModal from './Admin/BilagEmailPdfModal'
import HistoryItemBilagPdfModal from './Admin/HistoryItemBilagPdfModal'
import LabelModal from './Admin/Instillinger/Label/LabelModal'
import TilslagsskjermbildeSidebarNotesModal from './Admin/Auctions/Tilslagsskjermbilde/TilslagsskjermbildeSidebarNotesModal'
import DeliverObjektModal from './Admin/DeliverObjektModal'
import HistoryItemUtleveringsseddelPdfModal from './Admin/HistoryItemUtleveringsseddelPdfModal'
import KundeEmailModal from './Admin/KundeEmailModal'
import SignObjektModal from './Admin/SignObjektModal'
import SignedObjektModal from './Admin/SignedObjektModal'
import NotatImageLightboxModal from './Admin/NotatImageLightboxModal'

import bus from '@/plugins/event-bus'

export default {
  name: 'TheModal',
  components: {
    KundeCardCreateModal,
    KundeKontraktCreateModal,
    KundeKontraktObjektCreateModal,
    KundeKontraktObjekt,
    KundeKontraktSidebarNotater,
    KundeKontraktSidebarHistorikk,
    KundeFullmaktFormModal,
    KunstnerFormModal,
    KunstnerObjektListModal,
    AuksjonFormModal,
    KundeKontraktObjektSidebarNotater,
    KundeKontraktTransferModal,
    UserProfileModal,
    HistoryItemModal,
    KundeKontraktPrintModal,
    KundeKontraktObjektTabKjoperBilagModal,
    KundeKontraktObjektTabSelgerBilagModal,
    KundeKontraktObjektTabSelgerBilagDraftModal,
    MultiInvoiceModal,
    KundeKontraktInvoiceArModal,
    PrintLabelsModal,
    KundeAdresseModal,
    KundeKycModal,
    TheConfirm,
    EoFakturaModal,
    KrediteringBilagModal,
    KrediteringsBilagFakturaModal,
    BilagPdfModal,
    HistoryItemKontraktPdfModal,
    HistoryItemBesiktPdfModal,
    BekreftelsebrevPrintModal,
    ResultatbrevPrintModal,
    KundeKontraktObjektBesiktelseModal,
    DashboardOppgaveModal,
    LoginModal,
    BilagEmailPdfModal,
    HistoryItemBilagPdfModal,
    KundeKontraktObjektModal,
    LabelModal,
    TilslagsskjermbildeSidebarNotesModal,
    DeliverObjektModal,
    HistoryItemUtleveringsseddelPdfModal,
    KundeEmailModal,
    SignObjektModal,
    SignedObjektModal,
    NotatImageLightboxModal
  },
  computed: {
    isContainerActive () {
      return this.$store.getters.haveModals
    },
    modalStack () {
      return this.$store.getters.getStack
    }
  },
  methods: {
    getWindowClass (modal) {
      if (modal.modalType === 'left') {
        return 'sidepanel left scrollable active'
      } else if (modal.modalType === 'right') {
        return 'sidepanel right scrollable active'
      } else if (modal.modalType === 'fullscreen') {
        return 'fullscreen scrollable active'
      } else if (modal.modalType === 'large') {
        return 'large active'
      } else if (modal.modalType === 'medium') {
        return 'medium active'
      } else if (modal.modalType === 'split') {
        return 'large split active'
      } else if (modal.modalType === 'fullsplit') {
        return 'large fullheight split active'
      } else if (modal.modalType === 'confirm') {
        return 'small'
      } else {
        return 'centerpanel scrollable active'
      }
    },
    onClose: function (modal) {
      if (!modal) {
        modal = this.$store.getters.getCurrentModal
      }

      // We cannot allow to close confirms
      if (modal && modal.modalName === 'TheConfirm') {
        return
      }

      // Special check for objekt modal
      if (modal && modal.modalName === 'kunde-kontrakt-objekt') {
        if (this.isFormDirty('objektform')) {
          this.$helpers.showErrorAlert('', 'Du har gjort endringer på objektet,<br>vennligst lagre før du går videre.', true)
          return
        }
      }

      if (!modal || !modal.modalOnCloseEvent) {
        this.closeModal()
      } else {
        bus.$emit(modal.modalOnCloseEvent)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/TheModal.vue